
import store from '../store/index.js'
import common from "../js/common";

const common_pdd = {};

common_pdd.openpdd_host = 'https://api.wapg.cn/openpdd';
common_pdd.pdd_host = 'https://api.wapg.cn/pdd';

//选品列表(https://api.wapg.cn/openpdd/DdkGoodsSearch)
common_pdd.get_select_goods = common_pdd.openpdd_host + '/DdkGoodsSearch';
//拼多多爆款列表（https://api.wapg.cn/openpdd/ddkTopList）
common_pdd.get_top_goods = common_pdd.openpdd_host + '/ddkTopList';
//多多进宝推广链接生成 (https://api.wapg.cn/openpdd/ddkGoodsPromotionUrlGenerate)
common_pdd.make_pdd_links = common_pdd.openpdd_host + '/ddkGoodsPromotionUrlGenerate';
//拼多多类目获取（https://api.wapg.cn/openpdd/GoodsCatsGet）
common_pdd.get_goods_cats = common_pdd.openpdd_host + '/GoodsCatsGet';
//拼多多创建推广位id（http://api.wapg.cn/openpdd/PddPidGenerateRequest）
common_pdd.get_pingduoduo_pid = common_pdd.openpdd_host + '/PddPidGenerateRequest';

//商品详情接口(https://api.wapg.cn/taobao/getTbkScPublisherInfoGetRequest)
common_pdd.get_sku_detail_data = common_pdd.pdd_host + '/getTbkScPublisherInfoGetRequest';
//订单列表(https://api.wapg.cn/pdd/orderListApi)
common_pdd.get_order_list = common_pdd.pdd_host + '/orderListApi';

//订单详情接口地址(完成时间)(https://api.wapg.cn/taobao/orderByFinish)
common_pdd.get_order_by_Finish = common_pdd.pdd_host + '/orderByFinish';
//淘宝授权接口（https://oauth.taobao.com/authorize?response_type=code&client_id=28396368&redirect_uri=http://api.wapg.cn/taobao/getcode&state=1212&view=web
common_pdd.get_oauth_url = 'https://oauth.taobao.com/authorize?response_type=code&client_id=28396368&redirect_uri=http://api.wapg.cn/taobao/getcode&view=wap';
//收入统计
common_pdd.order_count_new = common_pdd.pdd_host + '/orderCountNew';
//指定日期预估收入列表
common_pdd.get_everyday_count_list = common_pdd.pdd_host + '/DayCount';
//群下级人数及对应收入
common_pdd.level_count_data = common_pdd.pdd_host + '/LeveCountData';
//一个代理的下级、下下级代理给当前代理所带来的预估提成佣金
common_pdd.pid_level_count_list = common_pdd.pdd_host + '/PidLevelCountListNew';
//用户可提款金额接口
common_pdd.user_pay_to = common_pdd.pdd_host + '/UserPayTo';
//用户提款明细接口：
common_pdd.user_pay_list = common_pdd.pdd_host + '/UserPayLists';
//获取提款纪录
common_pdd.get_order_by_sumbit = common_pdd.pdd_host + "/orderBySubmit";
//订单详情下载xls
common_pdd.get_order_by_finish_xls = common_pdd.pdd_host + "/orderByFinishXls";
//用户提现接口
common_pdd.user_submit = common_pdd.pdd_host + '/userSubmit';
//系统配置接口
common_pdd.sub_config = common_pdd.pdd_host + '/SubConfig';
//多多客是否授权备案接口
common_pdd.check_auth_record = common_pdd.openpdd_host + '/PddDdkMember';
//多多客绑定授权备案接口
common_pdd.get_bind_auth_record_data = common_pdd.openpdd_host + '/pddUrlGenerate';





//=====================类似全局变量=========================
common_pdd.back_from_count_new = false;
//提款操作来自于淘宝的数据页面
common_pdd.pay_from_pdd_data_page = false;
//详情页面是否展示中
common_pdd.is_show_pdd_sku_detail = false;
//预估佣金 私有比例
common_pdd.commissionRate_pir = 0.55;



common_pdd.getPddPid = function(){
    // return '9788668_131830157';
    if (common.isClient_whole()) {
        return store.state.channel_pdd_pid;
    }else{
        if(store.state.pdd_pid && store.state.pdd_pid !== 'undefined'){
            return store.state.pdd_pid;
        }else {
            return '';
        }
    }
}



export default common_pdd;
